import React, { useContext, useEffect } from 'react';
import {
  Input,
  onKeyPressDisallowSpecialCharacters,
} from 'src/components/Input';
import { useTranslation } from 'react-i18next';
import { ListContext } from '../context';
import { useForm } from 'react-hook-form';

export const FilterArnNumber = () => {
  const { dispatch, filters } = useContext(ListContext);

  const { t } = useTranslation();

  const { register, watch, setValue } = useForm<{
    arnNumber: string;
  }>();

  const { arnNumber } = watch();

  useEffect(() => {
    dispatch({
      type: 'SET_ARN_NUMBER_FILTER',
      arnNumber: arnNumber,
    });
  }, [arnNumber, dispatch]);

  useEffect(() => {
    setValue('arnNumber', filters.arnNumber);
  }, [filters.arnNumber, setValue]);

  return (
    <Input
      label={t('transactionsManagement.transactions.list.filters.arnNumber')}
      name="arnNumber"
      labelFontClassName="text-xxs font-medium"
      labelColorClassName="text-gray-700"
      className="h-8 text-xs font-bold"
      onKeyPress={onKeyPressDisallowSpecialCharacters}
      inputRef={register}
    />
  );
};
